import { WidgetsRolesMain } from '@/widgets/roles';

export const PagesRolesMain = () => <WidgetsRolesMain />;
